// extracted by mini-css-extract-plugin
export var required = "_g7-0";